import { formatMoney } from 'accounting'

import { Box, Text } from '@domain-group/suit-theme'

import type { CampaignModel } from '@models/types'

interface CampaignProps {
  campaign: CampaignModel,
}

const Campaign = (props: CampaignProps) => {
  const {
    campaign: {
      dates,
      id,
      price,
      suburb_name,
    },
  } = props

  if (!id){
    return null
  }

  return (
    <Box marginTop="large">
      <Box flexDirection="column">
        <Text color="bodyFontLightColor" fontSize="xsmall">
          Suburb: {suburb_name}
        </Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
          Price: {price ? formatMoney(price, { precision: 0, symbol: '$', format: '%s%v' }) : 'Not Set'}
        </Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
          Start Date: {dates?.start?.date || 'Not Set'}
        </Text>
      </Box>
    </Box>
  )
}

export default Campaign
